<template>
  <div class="email-verified" v-if="!user.emailVerified">
    <span>{{$t('emailVerify')}}</span>
    <div><router-link :to="{ name: 'AccountEmailEdit' }">{{$t('mailResend')}}</router-link></div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'EmailVerified',
  props: {
    user: firebase.User
  },
}
</script>

<style scoped>
.email-verified {
  text-align: center;
  margin: 1rem;
  padding: 0.5rem;
  border: 1px solid;
  border-color: #FCAA00;
  border-radius: 4px;
}
.email-verified span {
  font-size: 0.8rem;
}
.email-verified a {
  text-decoration: none;
  color: #FCAA00;
  font-size: 0.8rem;
}
</style>
